// A cell that starts with one of these is read as a formula by Excel/Sheets, so it is prefixed
// with a quote to keep it as text. Leading spaces are skipped first, because " =1+1" still evaluates.
const FORMULA_START = /^[=+\-@]/;

// Only free-text columns need the guard. Amounts such as "-$5.00" are meant to stay as they are.
export const escapeCsvCell = (value: unknown, { guardFormula = false }: { guardFormula?: boolean } = {}): string => {
    let text = value === null || value === undefined ? '' : String(value);
    if (guardFormula && FORMULA_START.test(text.trim())) {
        text = `'${text}`;
    }
    if (/[",\r\n]/.test(text)) {
        text = `"${text.replace(/"/g, '""')}"`;
    }
    return text;
};

export const buildCsv = (
    headers: string[],
    rows: string[][],
    { guardFormulaColumns = [] }: { guardFormulaColumns?: number[] } = {},
): string => {
    return [headers, ...rows]
        .map((row) => row.map((cell, index) => escapeCsvCell(cell, { guardFormula: guardFormulaColumns.includes(index) })).join(','))
        .join('\r\n');
};

// The BOM lets Excel read accented names as UTF-8.
export const downloadCsv = (fileName: string, csv: string): void => {
    const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Some browsers start the download after click() returns, so the URL has to outlive it.
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
